import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConnectionStatusEnum } from '../../globals-enums/connection-status.enum';
import { GlobalsService } from '../../globals-services/globals.service';
import { InvitationActionDialogComponent } from '../invitation-action-dialog/invitation-action-dialog.component';
@Component({
  selector: 'app-invitation-list',
  templateUrl: './invitation-list.component.html',
  styleUrls: ['./invitation-list.component.css']
})
export class InvitationListComponent implements OnInit {
  connectionInvitationList: any = [];
  ConnectionStatusEnum = ConnectionStatusEnum
  constructor(
    private http: HttpClient,
    private globalsService: GlobalsService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getInvitationList()
  }
  getInvitationList() {

    this.http.get<any[]>(this.globalsService.baseHref + '/shared/getMyInvitationList').subscribe((response) => {
      this.connectionInvitationList = response;

    },
      (err) => {
        console.log(err)
      });

  }
  openAcceptInvitationActionDialog(invitation) {
    const dialogRef = this.dialog.open(InvitationActionDialogComponent, {
      width: '40%',
      height: '30%',
      data: {
        invitation: invitation,

        type: 1,
        brandName: invitation.brandName
      }
    });

    dialogRef.afterClosed().subscribe(response => {

      this.dialog.closeAll();
      this.getInvitationList()


    });
  }
  openDisconnectConnActionDialog(invitation) {
    const dialogRef = this.dialog.open(InvitationActionDialogComponent, {
      width: '40%',
      height: '30%',
      data: {
        invitation: invitation,

        type: 2,
        brandName: invitation.brandName
      }
    });

    dialogRef.afterClosed().subscribe(response => {

      this.dialog.closeAll();
      this.getInvitationList()


    });
  }
}
